export default {"src":"/_next/static/media/clock.acc89389.svg","height":24,"width":24};